/* unplugin-vue-components disabled */import script from "./commonFooter.vue?vue&type=script&lang=ts&setup=true"
export * from "./commonFooter.vue?vue&type=script&lang=ts&setup=true"

import "./commonFooter.vue?vue&type=style&index=0&id=764396e5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-764396e5"]])

export default __exports__